import type { RuleTemplate } from '../../../../../interfaces/Interfaces';
import { ACTION_TYPE, CASE_ATTRIBUTE } from '../../../../../interfaces/enums';
import { ValidationResult } from '../../../../DunningSelectionPage/DunningSelection/input/Validators';

export function validateConditionIfDisconnectionAction(ruleEdit: RuleTemplate): ValidationResult | null {
  if (ruleEdit.actions.filter(action => action['@type'] === ACTION_TYPE.DISCONNECTION).length > 0) {
    const relevantConditions = ruleEdit.caseConditions.filter(
      condition => condition.attrib === CASE_ATTRIBUTE.DISCONNECTION_STATUS,
    );

    if (relevantConditions.length === 0) {
      return {
        error: true,
        message: 'error.rule-editor.missing-disconnection-cond',
      };
    }
  }
  return null;
}
